import styled from 'styled-components/macro';

export const ResetContainer = styled.div`
  padding: 25px;
  border-radius: 25px;
  background: white;
  width: 25vw;
  min-width: 392px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  box-shadow: 0px 0px 10px 5px rgb(0 0 0 / 25%);

  @media screen and (max-width: 471px) {
    min-width: 90vw;
  }

`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-height: ${({ height }) => height};
  height: ${({ height }) => height};

  z-index: 2;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;

  @media screen and (max-device-width: 767px) {
    overflow: hidden !important;
  }

  @media screen and (max-device-width: 767px) and (orientation: landscape) {
    display: none;
  }
  @media screen and (min-device-width: 768px) and (max-device-height: 549px) {
    display: none;
  }

  @media screen and (min-device-width: 768px) and (min-device-height: 550px) {
    display: none;
    max-height: 100vh;
    height: 100vh;

    @media screen and (min-width: 768px) and (min-height: 500px) {
      display: flex;
    }
  }
`;

export const GridHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 20px 0 20px;
  justify-content: space-between;
  box-sizing: border-box;
  position: relative;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
`;

export const GridList = styled.div`
  padding: 0 20px 20px 20px;
  box-sizing: border-box;

  width: 30vw;
  @media screen and (max-width: 1212px) {
    width: 40vw;
  }
  @media screen and (max-width: 842px) {
    width: 45vw;
  }

  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
`;

export const GridTask = styled.div`
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
  flex-direction: column;
`;
